import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="footer-utilities">
            <a
              href="https://www.kelsian.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              title="Privacy Policy"
            >
              Privacy Policy
            </a>
            Copyright &copy; {new Date().getFullYear()} Kelsian Group Limited
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
